export enum EmailAddressType {
  None = 0,
  Primary = 1,
  Business = 2,
  Personal = 3,
  Fax = 4
}
